import { API, REACT_APP_CREATORS_API_URL } from 'api'

import { FormTypes, TwinCampaign } from 'constants/types'

import { FormType } from 'shared'
import { formatCreatorStatusText } from 'utils/helpers'

const ENDPOINT = '/campaigns'

export const getCampaigns = (): Promise<TwinCampaign[]> => {
  return API.get(`${ENDPOINT}`).then((res) => {
    const newData: TwinCampaign[] = res.data.map((campaign: TwinCampaign) => {
      const creator = campaign.creators[0]
      if (!creator) return campaign
      return {
        ...campaign,
        creators: [
          {
            ...creator,
            status: {
              ...creator.status,
              text: formatCreatorStatusText(creator.status.code),
            },
          },
        ],
      }
    })

    return newData
  })
}

export const getCampaign = (id: number): Promise<TwinCampaign> => {
  return API.get<TwinCampaign>(`${ENDPOINT}/${id}`).then((res) => {
    const creator = res.data.creators[0]
    if (!creator) return res.data

    const newData: TwinCampaign = {
      ...res.data,
      creators: [
        {
          ...creator,
          status: {
            ...creator.status,
            text: formatCreatorStatusText(creator.status.code),
          },
        },
      ],
    }

    return newData
  })
}

export const rejectCampaign = ({
  id,
  data,
}: {
  id: number
  data: { declineOptionId: number | null; comment: string | null }
}) => {
  return API.post(`${ENDPOINT}/${id}/decline`, data).then((res) => res.data)
}

export const createCampaignForm = (
  id: number,
  data: { data: FormType; type: FormTypes; id?: number }
) => {
  return API.post(`${ENDPOINT}/${id}/forms`, data, {
    baseURL: REACT_APP_CREATORS_API_URL?.replace('v1', 'v2'),
  }).then((res) => res.data)
}

export const getDeclineCampaignOptions = (): Promise<
  {
    id: number
    text: string
  }[]
> => {
  return API.get(`${ENDPOINT}/decline-options`).then((res) => res.data)
}

export const getPointsByCampaign = (
  campaignId: number,
  creatorId: number
): Promise<{
  campaignId: number
  products: {
    productId: number
    points: number
  }[]
}> => {
  return API.get(`${ENDPOINT}/${campaignId}/points`, {
    params: {
      creatorId,
    },
  }).then((res) => res.data)
}
